
import {TRACKER_TYPES} from 'consts/ttypes'
import TrackerSelect from './tracker-select.vue'
import {markRaw} from 'vue'
import TrackerDelete from './tracker-delete.vue'
import CompanyTile from '../company-tile.vue'
import ContactItem from './contact-item.vue'
import {$contacts_groups} from 'stores/contacts2'
import $companies from 'stores/companies'
import PulseNum from '../pulse-num.vue'

export default {
  components: {
    TrackerSelect,
    TrackerDelete,
    CompanyTile,
    ContactItem,
    PulseNum
  },
  props: {
    search: {
      type: Boolean,
      default: false
    },
    chosenId: {
      type: String,
      default: undefined
    },
    hover: {
      type: Boolean,
      default: false
    },  
    item: {
      type: Object,
      required: true,
      // Expected structure: { name, type, people, signals, logo_url }
    },
    trackerWidth: {
      type: Number,
      default: undefined
    }
  },
  data(){
    
    return {
      open_contacts: false,
      TRACKER_OPTS: markRaw([
        {
          title: 'Edit company',
          icon: 'building-02',
          color: 'var(--brand-50)',
          onClick: () => this.$dispatch('edit-company', {company_id: this.item.id})
        },
        {
          title: 'Track a person',
          icon: 'user-03',
          color: 'var(--brand-50)',
          onClick: () => this.$dispatch('track-person', {company_id: this.item.id})
        },
        {
          title: 'Delete company',
          icon: 'trash-2',
          color: 'var(--brand-50)',
          onClick: this.onDeleteCompany
        },
      ]),
    }
  },
  computed: {
    opened(){
      return this.item.id === this.chosenId 
    },
    highlight(){
      return this.opened || this.contacts?.some(x => x.id === this.chosenId)
    },

    loading_contacts(){
      return this.contacts === undefined && this.open_contacts
    },
    tracker_type(){
      return TRACKER_TYPES.find(x => x.value === this.item?.type)
    },
    contacts(){
      if (!this.c_open_contacts) return undefined
      return $contacts_groups.getContacts(this.item.shared_company_id)
    },
    people(){
      return this.item.people
    },

    search_contacts(){
      return !!this.search && !!this.item.contacts?.length
    },
    c_open_contacts(){
      if (this.search_contacts) {
        return true
      }
      return this.open_contacts
    }
  },
  watch:{
    people(){
      if (this.people === 0) {
        this.open_contacts = false
      }
      if (!this.contacts) return
      // If the number of people and contacts are different, it means that contact migrated to another company or was created new contact
      if (this.people !== this.contacts.length) {
        this.loadContacts()
      }
    },
    'item.contacts'(){
      if (this.item.contacts?.length) {
        $contacts_groups.setContacts(this.item.shared_company_id, this.item.contacts)
      }
    },
  },
  methods: {
    editPerson(contact_id){
      this.$dispatch('edit-person', {contact_id, company_id: this.item.id})
    },
    trackPerson(){
      this.$dispatch('track-person', {company_id: this.item.id})
    },
    async openContacts(){
      if(!this.people) return
      if (this.open_contacts && this.opened) {
        this.open_contacts = false
        return
      }
      this.open_contacts = true
    },
    async loadContacts(){
      await $contacts_groups.load(
        {
          shared_company_id: this.item.shared_company_id, 
          company_id: this.item.user_entity_id
        }
      )
    },
    async onDeleteCompany() {
      const tracker = await $companies.loadCompany(this.item.id)
      this.$refs.delete.open(tracker)
    },
  }
}
